import { CampaignPick } from "../types/CampaignPick";
import { CampaignPickOption } from "../types/CampaignPickOption";

export const isSamePick = (a: CampaignPick, b: CampaignPick) =>
  a.kind === b.kind && a.id === b.id;

/** A result as it is kept once picked: only what the campaign needs */
export const toPick = ({
  blockedKey,
  tagIds,
  ...pick
}: CampaignPickOption): CampaignPick => pick;

/** What picking every shown result adds: the pickable ones not already picked,
 * one per number, and no more than the campaign has room for
 */
export const addablePicks = (
  options: CampaignPickOption[],
  picks: CampaignPick[],
  room: number,
): CampaignPick[] => {
  const waIds = new Set(picks.flatMap(({ waId }) => (waId ? [waId] : [])));
  const added: CampaignPick[] = [];

  for (const option of options) {
    if (added.length >= room) {
      break;
    }

    if (
      option.blockedKey ||
      picks.some((pick) => isSamePick(pick, option)) ||
      (option.waId && waIds.has(option.waId))
    ) {
      continue;
    }

    if (option.waId) {
      waIds.add(option.waId);
    }

    added.push(toPick(option));
  }

  return added;
};
